import React from "react";
import PropTypes from "prop-types";
import { Container } from "react-bootstrap";
import ModalApp from "../../../components/ModalApp";

export default function EmailRequiredModal({
  show,
  onClose,
  onRegisterEmail,
  onContinue,
}) {
  return (
    <ModalApp show={show} handleModal={onClose}>
      <Container className="py-4 px-4 text-center">
        <div className="d-flex justify-content-end" />
        <div className="d-flex justify-content-center mb-4" aria-hidden="true">
          <svg
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="44"
              cy="44"
              r="40"
              stroke="var(--text-dark)"
              strokeWidth="6"
              fill="transparent"
            />
            <rect
              x="41"
              y="22"
              width="6"
              height="34"
              rx="3"
              fill="var(--text-dark)"
            />
            <circle cx="44" cy="64" r="4" fill="var(--text-dark)" />
          </svg>
        </div>

        <h2
          style={{
            color: "var(--text-title)",
            fontWeight: 600,
            fontSize: "22px",
            lineHeight: 1.3,
            marginBottom: "16px",
          }}
        >
          Para uma experiência completa no Safra Rewards, complete seu cadastro.
        </h2>
        <p
          className="mb-4"
          style={{ color: "var(--primary-color)", fontSize: "16px" }}
        >
          Necessário cadastrar e-mail do usuário master.
        </p>

        <div className="d-flex flex-column align-items-center gap-3">
          <button
            type="button"
            className="btn-default-wl"
            style={{ maxWidth: "280px" }}
            onClick={onRegisterEmail}
          >
            CADASTRAR E-MAIL
          </button>
          <button
            type="button"
            className="btn-outline-wl"
            style={{ maxWidth: "280px" }}
            onClick={onContinue}
          >
            CONTINUAR SEM CADASTRAR
          </button>
        </div>
      </Container>
    </ModalApp>
  );
}

EmailRequiredModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRegisterEmail: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

